import React from "react";
import IColumnHeaderData from "../../models/shared/ColumnHeaderData";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";


interface ITableValues {
    list: any[];
    columns: IColumnHeaderData[];
    name?: string;
    labelNumber?: number;
    select: boolean;
    isFixedColumn: boolean;
    isEditable?: boolean;
    isTitle?: React.ReactNode;
    moduleName?: string;
    tableStyle?: string;
    setColor?: boolean;
    isTableShow?: boolean;
    isSecondaryTitle?: React.ReactNode;
    isRowClass?: string;
    cellEdit?: (e: any, rowIndex: number, colIndex: number) => void;
    errRowIndex?: any[];
    form?: boolean;
}

interface ITableState {

}

export default class AbbDashboardTableComponent extends React.Component<ITableValues, ITableState> {

    constructor(props: ITableValues) {
        super(props);
        this.state = {
            
        }
    }

    renderTableHeadData() {
        return (this.props.columns || []).map((key, index) => {
            return <th key={index} className={key.isFixed ? "abb-sticky-col row-data" : "row-data"}>{key.text}</th>
        });
    }

    renderTableData() {
        return (this.props.list).map((data, rowIndex) => {
            return (
                <tr key={rowIndex}>
                    {this.props.columns.map((val, colIndex) => {
                        let classnames = "normal-row";
                            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                            val.isFixed ? classnames += " abb-sticky-col" : null;
                            if (val.dataField.indexOf('.') !== -1 && typeof data === "object") {
                                const value = val.dataField.split(".");
                                var result: any = data;
                                value.forEach((element) => {
                                    result = result[element];
                                });
                                return <td key={colIndex} className={classnames}>
                                    {this.props.isEditable && val.isEditable ?
                                        <input
                                            className="table-input"
                                            type="text"
                                            name={val.dataField}
                                            value={result}
                                            maxLength={7}
                                            style={this.props.errRowIndex[0] === rowIndex
                                                && this.props.errRowIndex[1] === colIndex ? { border: "1px solid red" } : undefined}
                                        />
                                        : result
                                    }
                                </td>
                            } else {
                                let color = "black";
                                if (data.name === "Alarm Limit1") {
                                    color = CONSTANTS.ALARM_LIMIT1_COLOR;
                                } else if (data.name === "Alarm Limit2") {
                                    color = CONSTANTS.ALARM_LIMIT2_COLOR;
                                } else if (data.name === "Reject Limit") {
                                    color = "red";
                                }
                                return <td key={colIndex} className={classnames}>
                                    {this.props.isEditable && val.isEditable ?
                                        <input
                                            className="table-input"
                                            type="text"
                                            name={val.dataField}
                                            value={data[val.dataField]}
                                            maxLength={7}
                                            onChange={(e: any) => this.props.cellEdit(e, rowIndex, colIndex)}
                                        />
                                        :
                                        val.dataField === "currentlyMeasuring" ?
                                            <span style={{ color: "#3366FF" }}>{data[val.dataField]}</span>
                                            : data[val.dataField]
                                    }
                                </td>
                            }
                    })}
                </tr>
            )
        });
    }

    public render() {
        return (
            <Translation>
                {
                    t =>
                        <div className={this.props.form ? "w-100 pt-3" : "mt-3 w-100 p-3"}>
                            {this.props.isTitle}
                            <div className="float-right">
                                
                            </div>
                            <div className="clearfix" />

                            <hr className="hr-line-2" />

                            <div className="row mt-1 mb-1">
                                <div className="col-3">
                                    <div className="count-label">
                                        {t(CONSTANTS.LABEL_TOTAL)}
                                    </div>
                                    <div className="count-data">
                                        21
                                    </div>
                                </div>
                                <div className="col-3">
                                <div className="count-label">
                                        {t(CONSTANTS.LABEL_IN_USE)}
                                    </div>
                                    <div className="count-data">
                                        18
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="count-label">
                                        {t(CONSTANTS.LABEL_AVAILABLE)}
                                    </div>
                                    <div className="count-data">
                                        2
                                    </div>
                                </div>
                                <div className="col-3">
                                <div className="count-label">
                                        {t(CONSTANTS.LABEL_NOT_AVAILABLE)}
                                    </div>
                                    <div className="count-data">
                                        1
                                    </div>
                                </div>
                            </div>

                            <hr className="hr-line-1" />
                            
                            <div className="abb-wrapper">
                                <div className={this.props.isFixedColumn ? "abb-column-scroller" : "abb-scroller"}>
                                    <table className="dashboard-tbl">
                                        <thead>
                                            <tr>
                                                {this.renderTableHeadData()}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.renderTableData()}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div >
                }
            </Translation>
        );

    }
}



